var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecureCardSvgrepocom(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.4569 32.1985C78.6916 30.6342 78.7994 29.0538 78.7801 27.4721C74.0722 22.5795 68.4255 18.6872 62.1777 16.0287C55.9298 13.3701 49.2097 11.9995 42.4201 11.9995C35.6302 11.9995 28.9104 13.3701 22.6627 16.0287C16.415 18.6872 10.768 22.5795 6.06006 27.4721C6.06006 84.2743 42.4201 92.7987 42.4201 92.7987C45.1091 91.6606 47.7032 90.3096 50.1769 88.7587",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.94 56.439H54.54",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.86 44.1162H62.62C58.1575 44.1162 54.54 47.734 54.54 52.1962V72.3962C54.54 76.8588 58.1575 80.4762 62.62 80.4762H86.86C91.3226 80.4762 94.94 76.8588 94.94 72.3962V52.1962C94.94 47.734 91.3226 44.1162 86.86 44.1162Z",
    stroke: "#100808",
    strokeWidth: 5.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecureCardSvgrepocom);
export default __webpack_public_path__ + "static/media/secure-card_svgrepo.com.fca15dfa953731d72ccb56b1b5d2ddb4.svg";
export { ForwardRef as ReactComponent };